import { defineComponent as _defineComponent } from 'vue'
import Button from '@/components/ui/button/Button.vue'
import { AlertSettingsViewModel } from './viewmodels/AlertSettings.viewmodel'
import { AlertSettingsRepositoryApiAdapter } from '@/@core/fire-risk-settings/infra/alert-settings-repository-adapter/AlertSettingsRepositoryApi.adapter'
import SidePanel from '@/components/ui/sidePanel/SidePanel.vue'
import AlertSettingsForm from './components/AlertSettingsForm.vue'
import { onBeforeMount, provide, watch } from 'vue'
import BaseTable from '../../../../ui/components/baseTable/BaseTable.vue'
import Pagination from '@/components/ui/pagination/Pagination.vue'
import Input from '@/components/ui/input/Input.vue'
import EmptyTable from '@/components/ui/emty-table/EmptyTable.vue'
import ContextMenu from '@/components/ui/contextMenu/ContextMenu.vue'
import ConfirmationModal from '@/components/ui/confirmation-modal/ConfirmationModal.vue'
import SimpleTag from '@/@web/ui/components/SimpleTag.vue'
import { fireRiskApi } from '@/services/clients/AxiosClients'
import { MonitoredAreaRepositoryApiAdapter } from '@/@core/monitored-area/infra/monitored-area-repository-adapter/MonitoredAreaRepositoryApi.adapter'
import { useMessages } from '@/composables/useMessages'
import i18n from '@/VueI18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'AlertSettings.page',
  setup(__props) {

const { addMessage } = useMessages()

const repository = new AlertSettingsRepositoryApiAdapter(fireRiskApi)

const monitoredAreaRepository = new MonitoredAreaRepositoryApiAdapter(fireRiskApi, (skipped) => {
	addMessage({
		title: i18n.t('someFarmsNotDisplayed') as string,
		description: i18n.t('farmsWithInvalidGeometryHidden', { count: skipped.length }) as string,
		type: 'info',
	})
})

const vm = new AlertSettingsViewModel(repository, monitoredAreaRepository)

provide('alert-settings-view-model', vm)

watch(vm.openForm, (value) => {
	if (!value) vm.resetAlertSettingsState()
})

onBeforeMount(() => vm.getAlertSettings())

return { __sfc: true,addMessage, repository, monitoredAreaRepository, vm, Button, SidePanel, AlertSettingsForm, BaseTable, Pagination, Input, EmptyTable, ContextMenu, ConfirmationModal, SimpleTag }
}

})